<template>
<div id="detail-clinic">
        <modal :backdrop="false" size="lg" v-model="modal" class="detail-clinic-modal">
            <div slot="header">
                <button @click.prevent="closeModal" class="close" type="button">×</button>
                <div class="row">
                    <div class="col-xs-12 clinic-title"><h4 class="smalltitle">Detail Clinic - {{ user.fullName }} </h4></div>
                </div>
            </div>
            <div class="modal-header with-nav">
                <ul class="nav nav-tabs">
                    <li class="tab-item" :class="(selectedTab === tab.value ? 'active': '') + ' tab-user'+ tab.value "
                        @click="selectTab(tab.value)" v-for="tab in listTab"><a href="javascript:void(0)">{{ tab.name
                        }}</a>
                    </li>
                </ul>
            </div>
            <div class="content-tab">
                <tab-account-setting v-if="selectedTab === 1"
                                     :userInfo="userInfo" :payments="payments"
                                     :addressBillings="addressBillings"
                                     :disabledForm="disabledForm"
                                     :checkingAccounts="checkingAccounts"></tab-account-setting>
                <tab-general-info
                        v-if="selectedTab === 2"
                        :userInfo="userInfo"
                        :disabledForm="disabledForm"
                >
                </tab-general-info>

                <tab-clinic-location
                        v-if="selectedTab === 3"
                        :userInfo="userInfo"
                        :disabledForm="disabledForm"
                >
                </tab-clinic-location>
                <tab-emr-viewer-log v-if="selectedTab === 4" :clinic-id="user.id" />
                <tab-clearing-house v-if="selectedTab === 5" :key="user.id" :clinic-id="user.id" />
            </div>
            <div slot="footer">
                <button @click.prevent="closeModal" class="btn btn-default" type="button">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
import httpClient from '../../../client'
import DetailRegularUserMixin from '../../../mixins/user/UserStatusMixin'
import TabAccountSetting from './tab-regular-user/TabAccountSetting'
import TabGeneralInfo from './tab-clinic/TabGeneralInfo'
import TabClinicLocation from './tab-clinic/TabClinicLocation'
import TabEmrViewerLog from './tab-clinic/TabEmrViewerLog'
import TabClearingHouse from './tab-clinic/TabClearingHouse'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'

export default {
  name: 'DetailDoctor',
  components: { TabAccountSetting, TabGeneralInfo, TabClinicLocation, TabEmrViewerLog, TabClearingHouse },
  props: {
    user: {}
  },
  mixins: [ CommonMixin],
  data () {
    return {
      modal: false,
      selectedTab: 1,
      listTab: [
        {
          name: 'Account Setting',
          value: 1
        },
        {
          name: 'General Info',
          value: 2
        },
        {
          name: 'Clinic Locations',
          value: 3
        },
        {
          name: 'EMR Viewer Log',
          value: 4
        },
        {
          name: 'Setup Cleaning House',
          value: 5
        }
      ],

      userInfo: {},
      payments: [],
      addressBillings: [],
      checkingAccounts: []
    }
  },
  computed: {
    disabledForm () {
      return true
    }
  },
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
    this.getInfoAccount()
  },
  beforeDestroy () {
  },
  methods: {
    closeModal () {
      this.modal = false
    },
    selectTab (value) {
      this.selectedTab = Number(value)
    },
    async getInfoAccount () {
      try {
        let response = await httpClient.get('/users/detail-user/' + this.user.id + '?type=clinic')
        if (response.data.s === 200) {
          this.userInfo = response.data.data.user
          this.payments = response.data.data.payments
          this.addressBillings = response.data.data.addressBillings
          this.checkingAccounts = response.data.data.checkingAccounts
        } else {
          this.alertError(response.data.msg)
          this.modal = false
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style>
    .detail-clinic-modal .modal-dialog {
        width: calc(100% - 40px);
        max-width: 1400px;
        margin: 20px auto;
    }

    @media (max-width: 767px) {
        .detail-clinic-modal .modal-dialog {
            width: calc(100% - 20px);
            margin: 10px auto;
        }
    }
</style>
<style scoped="">
    .tab-item {
        cursor: pointer;
    }

    .clinic-title {
        padding-right: 35px;
    }

    .tab-item > a {
        white-space: normal;
    }

    .nav-tabs {
        display: flex;
        flex-wrap: wrap;
    }

    .tab-item {
        flex: 1 1 150px;
        min-width: 0;
        text-align: center;
    }
</style>
